import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import { DeleteSVGIcon } from '../Icons';

type Props = {
  onRemove?: () => void;
  onEdit?: () => void;
  onView?: () => void;
  onViewDetails?: () => void;
  hideRemove?: boolean;
  hideEdit?: boolean;
  hideDetails?: boolean;
  children?: ReactNode;
  IsVisualization?: boolean;
  disabledIcon?: boolean;
  disabledEditIcon?: boolean;
  childrenInTheEnd?: boolean;
  childrenInMiddle?: boolean;
};

function ActionsTable({
  onRemove,
  onEdit,
  onView,
  onViewDetails,
  hideRemove,
  hideEdit,
  hideDetails,
  children,
  IsVisualization = false,
  disabledIcon,
  disabledEditIcon,
  childrenInTheEnd = true,
  childrenInMiddle = false
}: Props) {
  const { t } = useTranslation('global');

  return (
    <Box
      id="actionsTable"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '::-webkit-scrollbar': {
          width: '10px',
          height: '5px'
        },
        '::-webkit-scrollbar-track': {
          background: '#f1f1f1'
        },
        '::-webkit-scrollbar-thumb': {
          background: '#15243e',
          borderRadius: '10px'
        },
        '::-webkit-scrollbar-thumb:hover': {
          background: '#15243e'
        }
      }}
    >
      {onView && (
        <IconButton onClick={onView}>
          <DescriptionIcon color="info" />
        </IconButton>
      )}

      {onViewDetails && !hideDetails && (
        <Tooltip placement="top" title={t('common.commonActions.viewDetails')}>
          <IconButton disabled={disabledIcon} onClick={onViewDetails}>
            <VisibilityOutlinedIcon
              color={disabledIcon ? 'disabled' : 'info'}
            />
          </IconButton>
        </Tooltip>
      )}

      {onEdit && !hideEdit && (
        <Tooltip
          placement="top"
          title={
            IsVisualization
              ? t('common.commonActions.view')
              : t('common.commonActions.edit')
          }
        >
          <IconButton disabled={disabledEditIcon} onClick={onEdit}>
            <EditIcon color={disabledIcon ? 'disabled' : 'warning'} />
          </IconButton>
        </Tooltip>
      )}

      {childrenInMiddle && children}

      {onRemove && !hideRemove && (
        <Tooltip placement="top" title={t('common.commonActions.delete')}>
          <IconButton disabled={disabledIcon} onClick={onRemove}>
            <DeleteSVGIcon
              colorFill={disabledIcon ? '#808080' : '#E63D3D'}
              isDisabled={disabledIcon}
            />
          </IconButton>
        </Tooltip>
      )}
      {childrenInTheEnd && children}
    </Box>
  );
}

export default ActionsTable;
